export const name = "KEYS.NEW_WRAPPED_KEYSET";
export const summary = `Creates a new keyset and encrypts it with a Cloud KMS key.`;
export const reference = `
## KEYS.NEW_WRAPPED_KEYSET

Creates a new keyset and encrypts it with a Cloud KMS key.

\`\`\`
KEYS.NEW_WRAPPED_KEYSET(kms_resource_name, key_type)
\`\`\`

### Description

Creates a new keyset and encrypts it with a Cloud KMS key. Returns the wrapped keyset as a \`BYTES\`representation of google.crypto.tink.Keysetthat contains a primary cryptographic key and no additional keys.

This function takes the following arguments:

- \`kms_resource_name\`: A \`STRING\` literal representation of the Cloud KMS key. \`kms_resource_name\` can't be \`NULL\`. The Cloud KMS key must reside in the same Cloud region where this function is executed. A Cloud KMS key looks like this:

- \`key_type\`: A \`STRING\` literal representation of the keyset type.\`key_type\` can't be \`NULL\` but can be one of the following values:


### Return Data Type

\`BYTES\`


### Example

Put the following variables above each example query that you run:



\`\`\`
DECLARE kms_resource_name STRING;
SET kms_resource_name = 'gcp-kms://projects/my-project/locations/us/keyRings/my-key-ring/cryptoKeys/my-crypto-key';
\`\`\`

The following query creates a wrapped keyset, which contains the ciphertext produced by encrypting a Tink keyset with the specified Cloud KMS key. If you run the query multiple times, it generates multiple wrapped keysets, and each wrapped keyset is unique to each query that's run.



\`\`\`
SELECT KEYS.NEW_WRAPPED_KEYSET(kms_resource_name, 'AEAD_AES_GCM_256');
\`\`\`

Multiple calls to this function with the same arguments in one query returns the same value. For example, the following query only creates one wrapped keyset and returns it for each row in a table called \`my_table\`.



\`\`\`
SELECT
  *,
  KEYS.NEW_WRAPPED_KEYSET(kms_resource_name, 'AEAD_AES_GCM_256')
FROM my_table
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/aead_encryption_functions
`;
